<template>
  <div class="w-full text-NotoSansLight">
    <div class="member-content">
      <div class="member-content-hd mb-8 pt-3 px-2 sm:hidden">
        <h3 class="text-NotoSansRegular text-base lg:text-lg pb-1 border-b sm:border-b-0 sm:text-center">
          訂單查詢
        </h3>
      </div>

      <div class="member-content-bd">
        <p class="list-attention text-red-600 text-center text-sm text-NotoSansRegular">貼心提醒您，僅提供2020/6/10後之訂單查詢</p>
        <p class="list-attention text-red-600 text-center text-sm text-NotoSansRegular mb-3">
          若有其他需求，請洽客服信箱：<a class="underline text-blue-600" href="mailto:service@liveabc.com">service@liveabc.com</a></p>
        <div class="section section-latest-order min-h-50">

          <div class="main px-4 sm:px-0">
            <DeleteConfirm v-if="cancleAttributes.isConfirm" :id="cancleAttributes.id" v-on:closePop="closePop" />

            <table class="table-order w-full text-left" column="8" v-if="orderData !== null">
              <thead class="text-sm bg-gray-400 text-NotoSansRegular tracking-wider">
                <tr>
                  <th class="py-3 px-2 sm:text-center text-gray-700">訂購日期</th>
                  <th class="py-3 px-2 text-gray-700">訂單編號</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">訂單狀態</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">總金額</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">發票類型</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">載具類別</th>
                  <!-- <th class="py-3 px-2 sm:text-center text-gray-700">發票日期</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">發票號碼</th> -->
                  <th class="py-3 px-2 sm:text-center text-gray-700">物流資訊</th>
                  <th class="py-3 px-2 sm:text-center text-gray-700">中獎狀態</th>
                </tr>
              </thead>
              <tbody class="text-sm" :class="{ noData: orderData.length === 0 }">
                <tr v-for="(item, index) in orderDataCustom" :key="index">
                  <td class="sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">訂購日期：</span>
                    <span class="w-1/2 text-right sm:text-center  whitespace-no-wrap">{{ moment(item.created_at).format('YYYY/MM/DD HH:mm') }}</span>
                  </td>
                  <td class="sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">訂單編號：</span>
                    <router-link :to="{ path: 'orderdetail/' + item.id }"
                      class="w-1/2 sm:w-auto text-right sm:text-center hoverA cursor-pointer inline-block text-blue-600">
                      {{ item.id }}
                    </router-link>
                  </td>
                  <td class="sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">訂單狀態：</span>
                    <a class="w-1/2 sm:w-full text-right sm:text-center">
                      <span v-if="item.status === 'created'">收到訂單</span>
                      <span v-if="item.status === 'waiting'">等待付款</span>
                      <span v-if="item.status === 'payment_fail'">付款失敗</span>
                      <span v-if="item.status === 'paid'">完成付款</span>
                      <span v-if="item.status === 'delivery'">配送中</span>
                      <span v-if="item.status === 'finish'">訂單完成</span>
                      <span v-if="item.status === 'invalid'">訂單取消</span>
                      <span v-if="item.status === 'payment_warning'" class="textColorRed text-xs">匯款金額不符，詳情請聯絡客服<br/></span>
                      <span v-if="item.status === 'payment_warning'">訂單異常</span>
                    </a>
                    <a class="btn px-2 py-1 rounded text-sm text-NotoSansBold block whitespace-no-wrap cursor-pointer w-auto text-center" @click="rePay(index, item)"
                      v-if="(item.status === 'waiting' || item.status === 'payment_fail') && item.payment_info.type === 'CreditCard'">
                      重新付款
                    </a>
                    <form method="post" :action="$store.state.apiUrl + '/web/payment/creditcard'" target="_self"
                      :ref="'creditPay' + index" v-if="(item.status === 'waiting' || item.status === 'payment_fail') && item.payment_info.type === 'CreditCard'">
                      <input type="hidden" name="ordernumber" :value="item.id">
                      <input type="hidden" name="amount" :value="item.amount">
                      <input type="hidden" name="itemDesc" value="LiveABC EC Products">
                    </form>
                  </td>
                  <td class="sm:text-center sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">總金額：</span>
                    <span class="w-1/2 sm:w-auto text-right sm:text-center">NT.{{ item.amount }}</span>
                  </td>
                  <td class="sm:text-center sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2  mobile-label">發票類型：</span>
                    <a class="cursor-auto w-1/2 sm:w-auto text-right sm:text-center whitespace-pre-linep">
                      <span v-if="item.invoice_type === '紙本'">紙本</span>
                      <span v-if="item.invoice_type === '三聯式'">紙本-公司</span>
                      <span v-if="item.invoice_type === '捐贈'">捐贈</span>

                      <span v-if="item.invoice_type === '電子發票' && ((item.invoice_carrier_type === 1 && !item.tax_no && !item.tax_title) || (item.invoice_carrier_type === 2 && !item.tax_no && !item.tax_title) || (item.invoice_carrier_type === 3 && !item.tax_no && !item.tax_title))">電子發票-個人</span>

                      <span v-if="item.invoice_type === '電子發票' && item.tax_no && item.tax_title">電子發票-公司</span>
                    </a>
                  </td>
                  <td class="sm:text-center sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2  mobile-label">載具類別：</span>
                    <a class="cursor-auto w-1/2 sm:w-auto text-right sm:text-center whitespace-pre-wrap">
                      <span v-if="item.invoice_type === '紙本' || item.invoice_type === '捐贈'">無</span>
                      <!-- 公司戶/純紙本 -->
                      <span v-if="item.invoice_type === '電子發票' && !item.invoice_giving && item.invoice_send && item.tax_no && item.tax_title && !item.invoice_carrier">無</span>

                      <span v-if="item.invoice_type === '電子發票' && item.invoice_carrier_type === 1 && !item.invoice_send">會員載具</span>
                      <span v-if="item.invoice_type === '電子發票' && item.invoice_carrier_type === 2 && !item.invoice_send">自然人憑證條碼</span>
                      <!-- 個人/手機條碼 -->
                      <span v-if="item.invoice_type === '電子發票' && item.invoice_carrier_type === 3 && !item.tax_no && !item.tax_title && !item.invoice_send && item.invoice_carrier">手機條碼</span>
                      <!-- 公司戶/手機條碼+紙本 -->
                      <span v-if="item.invoice_type === '電子發票' && item.invoice_carrier_type === 3 && item.tax_no && item.tax_title && item.invoice_carrier">手機條碼</span>
                    </a>
                  </td>
                  <td class="sm:text-center sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">物流資訊：</span>
                    <a v-if="item.delivery_info && item.delivery_info.name && item.delivery_info.track_no" target="_blank" :href="logisticsUrl(item.delivery_info)" class="cursor-pointer w-1/2 sm:w-auto text-right sm:text-center whitespace-pre-wrap text-xs underline">
                      <p v-if="item.delivery_info.name">{{ deliveryName(item.delivery_info.name) }}</p>
                      <p v-if="item.delivery_info.track_no">{{ item.delivery_info.track_no }}</p>
                    </a>
                    <span v-if="item.delivery_info.length === 0 && (((item.status === 'paid' || item.status === 'delivery' || item.status === 'finish') && item.payment_info.type !== 'COD') || ((item.status === 'created' || item.status === 'waiting') && item.payment_info.type === 'COD'))">物流處理中</span>
                  </td>
                  <td class="sm:text-center sm:border-b text-gray-700 sm:px-2">
                    <span class="w-1/2 mobile-label">中獎狀態：</span>
                    <a class="cursor-auto w-1/2 sm:w-auto text-right sm:text-center whitespace-pre-wrap">
                      <span>{{ item.invoice_status }}</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12" v-else>

          </div>

        </div>
      </div>

      <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

    </div>

  </div>
</template>

<script>
import PaginateComponent from '@/components/modules/Paginatation'
import axios from 'axios'
import DeleteConfirm from '@/components/modules/DeleteConfirm'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'OrderList',
  data () {
    return {
      cancleAttributes: {
        isConfirm: false,
        id: null
      },
      orderData: null,
      // pagination
      pagination: {
        currentPage: 1,
        length: 5
      }
    }
  },
  components: {
    DeleteConfirm,
    PaginateComponent
  },
  computed: {
    ...mapGetters([
      'userRole'
    ]),
    orderDataCustom () {
      if (this.OrderNum) {
        return this.orderData.slice(0, this.OrderNum)
      } else {
        return this.orderData
      }
    }
  },
  mounted () {
    this.getData()
  },
  updated () {
  },
  methods: {
    getData () {
      let self = this
      axios.get(`/orders?page=${self.pagination.currentPage}&pageSize=10`)
        .then((response) => {
          self.orderData = response.data.data
          self.pagination.length = response.data.last_page
        })
    },
    cancleOrder (item) {
      this.cancleAttributes.isConfirm = true
      this.cancleAttributes.id = item
    },
    closePop (closePop) {
      this.cancleAttributes.isConfirm = closePop
    },
    returnQuery (item) {
      this.$router.push({ name: 'returnQuery', params: { id: item } })
    },
    async pageChangeHandler (pageChangeHandler) {
      this.pagination.currentPage = pageChangeHandler
      this.getData()
    },
    rePay (index, item) {
      let self = this

      if (item.status === 'waiting' && item.payment_info.type === 'CreditCard' && (moment(new Date()).format('x') <= moment(item.created_at).add(30, 'minutes').format('x'))) {
        self.$refs['creditPay' + index][0].submit()
      } else {
        self.$swal({
          icon: 'info',
          title: '訂單已逾時',
          showCancelButton: false,
          confirmButtonText: `OK`,
          customClass: {
            container: 'text-sm text-base',
            popup: 'text-base',
            title: 'text-xl',
            confirmButton: 'comfirmBtn px-6 py-3',
            cancelButton: 'comfirmBtn px-6 py-3',
            footer: 'text-sm textColorDarkBlack'
          }
        })
      }
    },
    deliveryName (name) {
      if (name === 't-cat') {
        return '黑貓宅急便'
      } else if (name === 'post') {
        return '郵局'
      } else if (name === 'hct') {
        return '新竹物流'
      } else {
        return '宅配通'
      }
    },
    logisticsUrl (item) {
      if (item && item.name && item.track_no) {
        if (item.name === 't-cat') { // 黑貓
          return `https://www.t-cat.com.tw/inquire/TraceDetail.aspx?BillID=${item.track_no}`
        } else if (item.name === 'post') { // 郵局
          return `https://postserv.post.gov.tw/pstmail/main_mail.html?targetTxn=EB500100`
        } else if (item.name === 'hct') { // 新竹物流
          return `https://www.hct.com.tw/search/searchgoods_n.aspx`
        } else { // 宅配通
          return `https://www.e-can.com.tw/`
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .table-order {
    tbody {
      tr {
        td {
          padding: .8rem 0;
        }
      }
    }
  }
  .table-order .mobile-label {
    display: none;
  }
  .member-content-bd a, .member-content-bd button span {
    position: relative;
    display: inline-block;
  }
  @media (min-width: 1025px) {
    .member-content-bd .hoverA:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: #3182ce;
      bottom: -2px;
    }
  }

  @media (max-width: 641px) {
    .table-order .mobile-label {
      display: inline-block !important;
      text-align: left;
    }
    .table-order thead tr:first-child {
        display: none;
      }
    .table-order tbody, .table-order td, .table-order tbody tr, .table-order td .mobile-label {
        display: block;
        text-align: left;
    }
    .table-order tbody tr {
        border: 1px solid #C4C4C4;
        border-radius: 5px;
        padding: 12px 16px;
        font-size: 0;
        margin-bottom: .6rem;
        box-sizing: border-box;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td {
        // width: 50%;
        display: inline-block;
        box-sizing: border-box;
        padding: 4px 4px 4px 0 !important;
        vertical-align: top;
        font-size: .9rem;
        font-weight: 900;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td>span {
        display: inline-block;
    }
  }
  .noData {
    height: auto;
    min-height: 20rem;
    display: block;
  }
  .btn {
    background-color: #e60012;
    color: white;
  }
</style>
